import { usePatientEncounters } from '@hook'
import { usePortalVisitSummaries } from '../../../../../hooks/usePatientSummary'
import ResultsTableLayout from '../Results/tableLayout'
import EncountersTable from './EncountersTable'

export default function Encounters() {
  const { encounters, encountersIncluded, encountersIsLoading } = usePatientEncounters()
  // Completed visit summaries — feature-flagged and 403-safe (empty list) inside the hook itself, so
  // this just passes whatever comes back straight to the table.
  const { summaries } = usePortalVisitSummaries()

  return (
    <ResultsTableLayout records={encounters || []} searchKey="chartEncounterSearch" title="Encounters">
      {records => (
        <EncountersTable
          included={encountersIncluded || []}
          isLoading={encountersIsLoading}
          records={records as any}
          summaries={summaries}
        />
      )}
    </ResultsTableLayout>
  )
}
